import * as Immutable from 'immutable';
import {
  CHANGE_PASSWORD_REQUESTED,
  CHANGE_PASSWORD_COMPLETED,
  CHANGE_PASSWORD_FAILED,
  RESET_CHANGE_PASSWORD_COMPLETED,
  RESET_CHANGE_PASSWORD_FAILED,
} from '../../actions/security/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  reset: null,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUESTED:
      return state
        .set('error', null)
        .set('reset', null)
        .set('gettingdata', true);

    case CHANGE_PASSWORD_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('reset', null)
        .set('gotdata', true)
        .set('data', action.payload);

    case CHANGE_PASSWORD_FAILED:
      return state.set('reset', null).set('error', action.payload);

    case RESET_CHANGE_PASSWORD_COMPLETED:
      return state.set('error', null).set('reset', true);

    case RESET_CHANGE_PASSWORD_FAILED:
      return state.set('reset', null).set('error', action.payload);
    default:
      return state;
  }
};

export { initialState };

export default reducer;
